import { Nullable } from 'types';
import type { Funnelable, LocationInfo } from '../types';
import { Funnel } from '../types';
import type { AccountLocations } from './account';

export default class AccountLocationsImpl
  implements AccountLocations, Funnelable
{
  main: LocationInfo = {
    pathname: '/account',
    funnels: [Funnel.ACCOUNT],
  };

  overview: LocationInfo = {
    pathname: '/account/overview',
    funnels: [Funnel.ACCOUNT],
  };

  subscription: LocationInfo = {
    pathname: '/account/subscription',
    funnels: [Funnel.ACCOUNT],
  };

  youTube: LocationInfo = {
    pathname: '/account/youtube',
    funnels: [Funnel.ACCOUNT],
  };

  funnelsForPathname(pathname: string): Nullable<Funnel[]> {
    const { main, overview, subscription, youTube } = this;
    if (pathname === main.pathname) return main.funnels;
    if (pathname === overview.pathname) return overview.funnels;
    if (pathname === subscription.pathname) return subscription.funnels;
    if (pathname === youTube.pathname) return youTube.funnels;
    return null;
  }
}
